import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreComponent } from './component/core.component';
import { AppConfigService } from '@citi-gcg-173875/citi-utils';
import { MktSessionService } from './services/mkt-session.service';
import { MktSiteCatalystService } from './services/mkt-site-catalyst.service';
import { MktEnvironmentService } from './services/mkt-environment.service';
import { MktSEOService } from './services/mkt-seo.service';
import { MktCommonModule } from '../common/mkt-common.module';
import { HttpClientModule } from '@angular/common/http';
import { MktDynamicOfferService } from './services/mkt-dynamic-offer.service';
import { EnvironmentUrlPipe } from '../common/pipes/environment-url.pipe';
import { EmergencyAlertsComponent } from './component/emergency-alerts/emergency-alerts.component';
import { BannerAlert, Icons2, Modal, CTA } from '@citi-gcg-173875/citi-common-ui';
import { MktContentStorageService } from './services/mkt-content-storage.service';
import { MktContentStaticService } from './services/mkt-content-static.service';
import { MktCardRetrievalService } from './services/mkt-card-retrieval.service';
import { MktModalInstance, MktModalService } from './services/mkt-modal.service';
import { CookieService } from '@citi-gcg-173875/citi-utils';

@NgModule({
  imports: [
    CommonModule,
    MktCommonModule,
    HttpClientModule,
    BannerAlert,
    Icons2,
    Modal,
    CTA
  ],
  declarations: [
    CoreComponent,
    EmergencyAlertsComponent
  ],
  exports: [
    CoreComponent
  ],
  providers: [
    AppConfigService,
    MktSessionService,
    MktSiteCatalystService,
    MktEnvironmentService,
    MktSEOService,
    MktDynamicOfferService,
    MktContentStorageService,
    MktContentStaticService,
    MktCardRetrievalService,
    MktModalService,
    MktModalInstance,
    CookieService,
    EnvironmentUrlPipe
  ]
})
export class CoreModule {

  constructor() {}
}
